module.exports = __webpack_public_path__ + "static/media/LEIE.11aaf89f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/LEIE.jpg
// module id = 1359
// module chunks = 1